import { reactive, toRefs } from "vue";
let data = reactive({
  standardSamplingInfo: [], //标准样取色信息
  dyeSamplingInfo: [], //染色样取色信息
  dyeColorDiffTable: [], //染色样色差值表格
  //===================
  illuminantIds: [], //光源
  // spectrums: [],//标准样反射率
  // dyeSpectrums: [],//染色样反射率
  products: [], //染色液配方
  fabricInfo: {}, //织物信息
  fabricId: undefined, //织物id
  fabricKind: undefined, //织物类型 0:真实纤维 1:虚拟纤维
  fabricName: undefined, //织物名
  clothKindId: undefined,
  gramWeightId: undefined,
  processId: undefined,
  bathRatioId: undefined,
  equipmentId: undefined, //精明配色标识id
  equipmentName: undefined, //精明配色标识名
  codeNum: undefined, //配方代号
  formulaId: undefined, //接口返回配方ID
  dEType: undefined, // 色差标准
});
const methods = {
  init() {
    data.standardSamplingInfo = [];
    data.dyeSamplingInfo = [];
    data.dyeColorDiffTable = [];
    data.illuminantIds = [];
    data.products = [];
    data.fabricId = undefined;
    data.fabricName = undefined;
    data.fabricInfo = {};
    data.equipmentId = undefined;
    data.equipmentName = undefined;
    data.codeNum = undefined;
    data.formulaId = undefined;
    data.clothKindId = undefined;
    data.gramWeightId = undefined;
    data.bathRatioId = undefined;
    data.processId = undefined;
  },
  // 缓存数据
  hCache() {
    sessionStorage.setItem("dAdjustmentData", JSON.stringify(data));
  },
  //  取数据
  hgetData() {
    let obj = JSON.parse(sessionStorage.getItem("dAdjustmentData"));
    if (!obj) return;
    data.standardSamplingInfo = obj.standardSamplingInfo; //标准样取色信息
    data.dyeSamplingInfo = obj.dyeSamplingInfo; //染色样取色信息
    data.dyeColorDiffTable = obj.dyeColorDiffTable; //染色样色差值表格
    data.illuminantIds = obj.illuminantIds; //光源
    data.products = obj.products; //染色液配方
    data.fabricInfo = obj.fabricInfo; //织物信息
    data.fabricId = obj.fabricId; //织物id
    data.fabricKind = obj.fabricKind; //织物类型 0=真实纤维 1=虚拟纤维
    data.fabricName = obj.fabricName; //织物名
    data.clothKindId = obj.clothKindId;
    data.gramWeightId = obj.gramWeightId;
    data.processId = obj.processId;
    data.bathRatioId = obj.bathRatioId;
    data.equipmentId = obj.equipmentId; //精明配色标识id
    data.equipmentName = obj.equipmentName; //精明配色标识名
    data.codeNum = obj.codeNum; //配方代号
    data.formulaId = obj.formulaId; //接口返回配方ID
    data.dEType = obj.dEType; // 色差标准
  },
};
export default {
  data,
  ...toRefs(data),
  ...methods,
};
